import { render, staticRenderFns } from "./AddSelectRecd.vue?vue&type=template&id=3ed44141&scoped=true&"
import script from "./AddSelectRecd.vue?vue&type=script&lang=js&"
export * from "./AddSelectRecd.vue?vue&type=script&lang=js&"
import style0 from "./AddSelectRecd.vue?vue&type=style&index=0&id=3ed44141&lang=less&scoped=true&"
import style1 from "./AddSelectRecd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed44141",
  null
  
)

export default component.exports